import { union } from 'io-ts/Decoder';

import { Id as FPCJobId } from '../fpc/job/Id';
import { Id as JobId } from '../job/Id';
import { Id as CanvasId } from '../whole-house/canvas/Id';

export const ParentId = union(JobId, FPCJobId, CanvasId);
